import axios from 'axios';
import { authHeader } from './auth.header';
import config from "../environment/config";
const API_URL = config.API_URL;


export const authenticationDetails = async (loginData) => {
  try {
    return await axios.post(
      `${API_URL}authenticate`,
      JSON.stringify(loginData),
      {
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      }
    );
  } catch (error) {
    console.error('Error occurred in authenticationDetails:', error);
    throw error;
  }
};

export const getRoleDetails = async () => {
  try {
    return (await axios.get(`${API_URL}get-role-details`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getRoleDetails():', error);
    throw error;
  }
};

export const checkUsername = async (username) => {
  try {
    return (await axios.get(`${API_URL}check-username`,
      {
        params: { username },
        headers: { 'Content-Type': 'application/json', ...authHeader() }
      })).data;
  } catch (error) {
    console.error('Error occurred in checkUsername:', error);
    throw error;
  }
};

export const createUser = async (userData) => {
  try {
    return (await axios.post(`${API_URL}create-user`, userData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getRoleDetails():', error);
    throw error;
  }
};

export const updateUser = async (userData) => {
  try {
    return (await axios.put(`${API_URL}update-user`, userData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in updateUser():', error);
    throw error;
  }
};

export const getUserById = async (loginId) => {
  try {
    return (await axios.get(`${API_URL}get-user-detail-byId`,
      {
        params: { loginId },
        headers: { 'Content-Type': 'application/json', ...authHeader() }
      })).data;
  } catch (error) {
    console.error('Error occurred in getUserById():', error);
    throw error;
  }
};

export const getUserMasterList = async () => {
  try {
    return (await axios.get(`${API_URL}get-user-list`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getRoleDetails():', error);
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await axios.delete(`${API_URL}delete-user/${userId}`, {
      headers: {
        'Content-Type': 'application/json',
        ...authHeader(),
      },
    });
    return response.status === 204;
  } catch (error) {
    console.error('Error occurred in deleteUser():', error);
    return false;
  }
};

export const getPoojaMasterList = async () => {
  try {
    return (await axios.get(`${API_URL}api/tblpoojatypes`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getPoojaMasterList():', error);
    throw error;
  }
};

export const createPooja = async (poojaData) => {
  try {
    return (await axios.post(`${API_URL}api/tblpoojatypes`, poojaData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in createPooja():', error);
    throw error;
  }
};

export const updatePooja = async (poojaId, poojaData) => {
  try {
    return (await axios.patch(`${API_URL}api/tblpoojatypes/${poojaId}`, poojaData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in updatePooja():', error);
    throw error;
  }
};

export const deletePooja = async (poojaId) => {
  try {
    const response = await axios.delete(`${API_URL}api/tblpoojatypes/${poojaId}`, { headers: { 'Content-Type': 'application/json', ...authHeader(), }, });
    return response.status === 204;
  } catch (error) {
    console.error('Error occurred in deletePooja():', error);
    throw error;
  }
}

export const getPoojaById = async (poojaId) => {
  try {
    return (await axios.get(`${API_URL}api/tblpoojatypes/${poojaId}`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getPoojaById():', error);
    throw error;
  }
}

export const getJaThaPraMasterList = async () => {
  try {
    return (await axios.get(`${API_URL}api/add-jathapras`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getJaThaPraMasterList():', error);
    throw error;
  }
}

export const createJaThaPra = async (jaThaPraData) => {
  try {
    return (await axios.post(`${API_URL}api/add-jathapras`, jaThaPraData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in createJaThaPra():', error);
    throw error;
  }
};

export const getNakshatraMasterList = async () => {
  try {
    return (await axios.get(`${API_URL}api/tblnakshatras`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getNakshatraMasterList():', error);
    throw error;
  }
};

export const createNakshatra = async (nakshatraData) => {
  try {
    return (await axios.post(`${API_URL}api/tblnakshatras`, nakshatraData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in createNakshatra():', error);
    throw error;
  }
}

export const updateNakshatra = async (nakshatraId, nakshatraData) => {
  try {
    return (await axios.patch(`${API_URL}api/tblnakshatras/${nakshatraId}`, nakshatraData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in updateNakshatra():', error);
    throw error;
  }
};

export const deleteNakshatra = async (nakshatraId) => {
  try {
    const response = await axios.delete(`${API_URL}api/tblnakshatras/${nakshatraId}`, { headers: { 'Content-Type': 'application/json', ...authHeader(), }, });
    return response.status === 204;
  } catch (error) {
    console.error('Error occurred in deleteNakshatra():', error);
    throw error;
  }
}

export const getNakshatraById = async (nakshatraId) => {
  try {
    return (await axios.get(`${API_URL}api/tblnakshatras/${nakshatraId}`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getNakshatraById():', error);
    throw error;
  }
}

export const getGotraMasterList = async () => {
  try {
    return (await axios.get(`${API_URL}api/tblgotras`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getGotraMasterList():', error);
    throw error;
  }
};

export const createGotra = async (gotraData) => {
  try {
    return (await axios.post(`${API_URL}api/tblgotras`, gotraData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in createGotra():', error);
    throw error;
  }
};

export const updateGotra = async (gotraId, gotraData) => {
  try {
    return (await axios.patch(`${API_URL}api/tblgotras/${gotraId}`, gotraData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in updateGotra():', error);
    throw error;
  }
};

export const deleteGotra = async (gotraId) => {
  try {
    const response = await axios.delete(`${API_URL}api/tblgotras/${gotraId}`, { headers: { 'Content-Type': 'application/json', ...authHeader() } });
    return response.status === 204;
  } catch (error) {
    console.error('Error occurred in deleteGotra():', error);
    throw error;
  }
};

export const getGotraById = async (gotraId) => {
  try {
    return (await axios.get(`${API_URL}api/tblgotras/${gotraId}`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getGotraById():', error);
    throw error;
  }
};

export const getPrathanaMasterList = async () => {
  try {
    return (await axios.get(`${API_URL}api/tblprathanas`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getPrathanaMasterList():', error);
    throw error;
  }
}

export const createPrathana = async (prathnaData) => {
  try {
    return (await axios.post(`${API_URL}api/tblprathanas`, prathnaData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in createPrathana():', error);
    throw error;
  }
};

export const getEkadasiMasterList = async (fromDate, toDate) => {
  try {
    const params = new URLSearchParams({
      fromDate: fromDate,
      toDate: toDate
    })
    return (await axios.get(`${API_URL}api/tblekadasis?${params.toString()}`,
      {
        headers: { 'Content-Type': 'application/json', ...authHeader() }
      })).data;
  } catch (error) {
    console.error('Error occurred in getEkadasiMasterList():', error);
    throw error;
  }
}

export const getAllEkadasiList = async () => {
  try {
    return (await axios.get(`${API_URL}api/tblekadasis/all`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getAllEkadasiList():', error);
    throw error;
  }
}

export const createEkadasi = async (ekadasiData) => {
  try {
    return (await axios.post(`${API_URL}api/tblekadasis`, ekadasiData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in createEkadasi():', error);
    throw error;
  }
};

export const getEkadasiById = async (ekadasiId) => {
  try {
    return (await axios.get(`${API_URL}api/tblekadasis/${ekadasiId}`, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in getEkadasiById():', error);
    throw error;
  }
};

export const updateEkadasi = async (ekadasiId, ekadasiData) => {
  try {
    return (await axios.patch(`${API_URL}api/tblekadasis/${ekadasiId}`, ekadasiData, { headers: { 'Content-Type': 'application/json', ...authHeader() } })).data;
  } catch (error) {
    console.error('Error occurred in updateEkadasi():', error);
    throw error;
  }
};

export const deleteEkadasi = async (ekadasiId) => {
  try {
    const response = await axios.delete(`${API_URL}api/tblekadasis/${ekadasiId}`, { headers: { 'Content-Type': 'application/json', ...authHeader() } });
    return response.status === 204;
  } catch (error) {
    console.error('Error occurred in deleteEkadasi():', error);
    throw error;
  }
};

export const changePassword = async (values) => {
  try {
    return (await axios.post(`${API_URL}change-password`, values, { headers: { 'Content-Type': 'application/json', ...authHeader() } }));
  } catch (error) {
    console.error('Error occurred in changePassword():', error);
    throw error;
  }
};





export const checkEmail = async (email) => {
  try {
    return (await axios.get(`${API_URL}check-email`,
      {
        params: { email },
        headers: { 'Content-Type': 'application/json', ...authHeader() }
      })).data;
  } catch (error) {
    console.error('Error occurred in checkEmail:', error);
    throw error;
  }
};

export const getAuditStampingList = async (userName) => {
  try {
    const params = userName ? { userName } : {};
    return (await axios.get(`${API_URL}api/audit-stamping`, {
      params,
      headers: { 'Content-Type': 'application/json', ...authHeader() }
    })).data;
  } catch (error) {
    console.error('Error occurred in getAuditStampingList():', error);
    throw error;
  }
};

export const getPaymentTransactionList = async () => {
  try {
    return (await axios.get(`${API_URL}api/paymentTransactions`, {
      headers: { 'Content-Type': 'application/json', ...authHeader() }
    })).data;
  } catch (error) {
    console.error('Error occurred in getPaymentTransactionList():', error);
    throw error;
  }
};
